<div class="row pb-4 gy-3">
  <div class="col-sm-4">
    <ng-select
      [(ngModel)]="selectedOption1"
      [items]="options"
      bindLabel="label"
      bindValue="value"
      [placeholder]="'SEARCH_BUILDINGS_AND_APARTMENTS' | translate"
      [searchable]="true"
      [multiple]="false"
    >
    </ng-select>
  </div>
  <div class="col-sm-4">
    <ng-select
      [(ngModel)]="selectedOption2"
      [items]="buildings"
      bindLabel="label"
      bindValue="value"
      [searchable]="false"
    >
      <ng-template ng-placeholder-tmp>
        @if (!selectedOption2) {
          <i class="bi bi-building me-2"></i> {{ 'BUILD_DASHBOARD.PROPERTY' | translate }}
        }
      </ng-template>
    </ng-select>
  </div>
  <div class="col-sm-4">
    <ng-select
      [(ngModel)]="selectedOption3"
      [items]="apartment"
      bindLabel="label"
      bindValue="value"
      [searchable]="false"
    >
      <ng-template ng-placeholder-tmp>
        @if (!selectedOption2) {
          <i class="bi bi-building me-2"></i> {{ 'BUILD_DASHBOARD.APARTMENT' | translate }}
        }
      </ng-template>
    </ng-select>
  </div>
</div>

<app-page-title title="Building Dashboard" [breadcrumbItems]="[]"></app-page-title>
<div class="row d-flex align-items-stretch mb-4">
  <div class="col-sm-12 col-md-3 d-flex ">
    <div class="card d-flex w-100 border border-primary rounded-4 my-0">
      <div class="d-flex justify-content-between m-4">
        <div class="d-flex align-items-center">
          <div class="donut-chart-container">
            <apx-chart [series]="donutChartOptions.series"
                       [chart]="donutChartOptions.chart"
                       [colors]="donutChartOptions.colors"
                       [legend]="donutChartOptions.legend"
                       [dataLabels]="donutChartOptions.dataLabels"
                       [plotOptions]="donutChartOptions.plotOptions"
                       class="apex-charts">
            </apx-chart>
            <i class="ri-fire-line center-icon" [style.color]="'#801130'"></i>
          </div>
          <h3 class="m-0">{{ 'BUILD_DASHBOARD.HEATING' | translate }}</h3>
        </div>
        <button type="button" class="btn btn-light btn-icon btn-rounded">
          <i class="ri-arrow-right-up-fill" style="font-size: 1.5rem">
          </i></button>
      </div>
      <h3 class="mb-3 mx-4 px-2">120 <small class="text-muted">{{ 'BUILD_DASHBOARD.GCAL' | translate }}</small></h3>
    </div>
  </div>
  <div class="col-sm-12 col-md-3 d-flex ">
    <div class="card d-flex w-100 border border-primary rounded-4 my-0">
      <div class="d-flex justify-content-between m-4">
        <div class="d-flex align-items-center">
          <div class="donut-chart-container">
            <apx-chart [series]="donutChartOptions.series"
                       [chart]="donutChartOptions.chart"
                       [colors]="['#5785fc','#00000000']"
                       [legend]="donutChartOptions.legend"
                       [dataLabels]="donutChartOptions.dataLabels"
                       [plotOptions]="donutChartOptions.plotOptions"
                       class="apex-charts">
            </apx-chart>
            <i class="ri-drop-line center-icon" [style.color]="'#5785fc'"></i>
          </div>
          <h3 class="m-0">{{ 'BUILD_DASHBOARD.COLD_WATER' | translate }}</h3>
        </div>
        <button type="button" class="btn btn-light btn-icon btn-rounded">
          <i class="ri-arrow-right-up-fill"
             style="font-size: 1.5rem"></i>
        </button>
      </div>
      <h3 class="mb-3 mx-4 px-2">164 <small class="text-muted"><span>&#13221;</span></small></h3>
    </div>
  </div>
  <div class="col-sm-12 col-md-3 d-flex ">
    <div class="card d-flex w-100 border border-primary rounded-4 my-0">
      <div class="d-flex justify-content-between m-4">
        <div class="d-flex align-items-center">
          <div class="donut-chart-container">
            <apx-chart [series]="donutChartOptions.series"
                       [chart]="donutChartOptions.chart"
                       [colors]="['#b69d16','#00000000']"
                       [legend]="donutChartOptions.legend"
                       [dataLabels]="donutChartOptions.dataLabels"
                       [plotOptions]="donutChartOptions.plotOptions"
                       class="apex-charts">
            </apx-chart>
            <i class="ri-drop-line center-icon" [style.color]="'#b69d16'"></i>
          </div>
          <h3 class="m-0">{{ 'BUILD_DASHBOARD.HOT_WATER' | translate }}</h3>
        </div>
        <button type="button" class="btn btn-light btn-icon btn-rounded">
          <i class="ri-arrow-right-up-fill" style="font-size: 1.5rem"></i>
        </button>
      </div>
      <h3 class="mb-3 mx-4 px-2">186 <small class="text-muted"><span>&#13221;</span></small></h3>
    </div>
  </div>
  <div class="col-sm-12 col-md-3 d-flex ">
    <div class="card d-flex w-100 border border-primary rounded-4 my-0">
      <div class="d-flex justify-content-between m-4">
        <div class="d-flex align-items-center">
          <h3 class="m-0">{{ 'BUILD_DASHBOARD.OTHER' | translate }}</h3>
        </div>
        <button type="button" class="btn btn-light btn-icon btn-rounded">
          <i class="ri-arrow-right-up-fill" style="font-size: 1.5rem"></i>
        </button>
      </div>
    </div>
  </div>
</div>

<!--second line of charts-->
<div class="row d-flex align-items-stretch mb-4">
  <div class="col-9 ">
    <div class="card border border-primary rounded-4 my-0 p-4">
      <h4 class="m-0 card-title border border-2 rounded-5 p-2 mb-3">{{ 'BUILD_DASHBOARD.COLD_WATER_READINGS' | translate }}</h4>
      <apx-chart [series]="stackedColumnChartOptions.series" [chart]="stackedColumnChartOptions.chart"
                 [plotOptions]="stackedColumnChartOptions.plotOptions"
                 [dataLabels]="stackedColumnChartOptions.dataLabels" [xaxis]="stackedColumnChartOptions.xaxis"
                 [grid]="stackedColumnChartOptions.grid" [colors]="stackedColumnChartOptions.colors"
                 [legend]="stackedColumnChartOptions.legend" [fill]="stackedColumnChartOptions.fill">
      </apx-chart>
    </div>
  </div>
  <div class="col-3 align-middle d-flex">
    <div class="card border border-primary rounded-4 my-0 p-4 ">
      <h4 class="m-0 card-title border justify-content-center d-flex border-2 rounded-5 p-2 mb-3">{{ 'BUILD_DASHBOARD.PER_OF_EXPENSES' | translate }}</h4>
      <apx-chart [series]="structureWidget.series" [chart]="structureWidget.chart"
                 [labels]="structureWidget.labels" [colors]="structureWidget.colors"
                 [plotOptions]="structureWidget.plotOptions" [legend]="structureWidget.legend"
                 [dataLabels]="structureWidget.dataLabels" [responsive]="structureWidget.responsive">
      </apx-chart>
    </div>
  </div>
</div>

<!--Third line of charts-->
<div class="row d-flex align-items-stretch mb-4">
  <div class="col-6 ">
    <div class="card border border-primary rounded-4 my-0 p-4">
      <h4 class="m-0 card-title border border-2 rounded-5 p-2 mb-3">{{ 'BUILD_DASHBOARD.HOT_WATER_READINGS' | translate }}</h4>
      <apx-chart [series]="stackedColumnChartOptions.series" [chart]="stackedColumnChartOptions.chart"
                 [plotOptions]="stackedColumnChartOptions.plotOptions"
                 [dataLabels]="stackedColumnChartOptions.dataLabels" [xaxis]="stackedColumnChartOptions.xaxis"
                 [grid]="stackedColumnChartOptions.grid" [colors]="['#b69d16']"
                 [legend]="stackedColumnChartOptions.legend" [fill]="stackedColumnChartOptions.fill">
      </apx-chart>
    </div>
  </div>
  <div class="col-6 ">
    <div class="card border border-primary rounded-4 my-0 p-4">
      <h4 class="m-0 card-title border border-2 rounded-5 p-2 mb-3">{{ 'BUILD_DASHBOARD.MONETARY_SHARE' | translate }}</h4>
      <apx-chart [series]="[
      {
      name: 'Hot water',
      data: [100, 200, 123, 189, 212, 143, 136, 148, 124, 128, 236, 144]
      },
      {
      name: 'Cold water',
      data: [400, 148, 421, 152, 222, 143, 236, 148, 224, 128, 223, 414]
      },
       {
      name: 'Heating',
      data: [100, 248, 221, 252, 122, 343, 136, 248, 124, 228, 323, 114]
      },
      ]"
                 [chart]="stackedColumnChartOptions.chart"
                 [plotOptions]="stackedColumnChartOptions.plotOptions2"
                 [dataLabels]="stackedColumnChartOptions.dataLabels2" [xaxis]="stackedColumnChartOptions.xaxis"
                 [grid]="stackedColumnChartOptions.grid" [colors]="['#b69d16','#5785fc','#801130']"
                 [legend]="stackedColumnChartOptions.legend" [fill]="stackedColumnChartOptions.fill">
      </apx-chart>
    </div>
  </div>
</div>
